<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormArmazon" role="form" method="post" autocomplete="off" onSubmit="return false">
                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <label class="form-label" for="Nombre">Nombre</label>
                            <input type="text" v-model="objArmazon.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
                            <CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
                        </div>
                    </div>

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="IdBisel">Bisel</label>
                            <select class="form-control form-select" name="IdBisel" id="IdBisel" v-model="objArmazon.IdBisel" >
                                <option value="">Seleccione una opción</option>
                                <option v-for="(item, index) in CmbListBiseles" :key="index" :value="item.IdBisel">{{ item.Nombre }}</option>
                            </select>
							<!-- <input type="text" v-model="objArmazon.IdBisel" class="form-control" id="IdBisel" placeholder="Ingresar IdBisel" /> -->
							<CValidation v-if="this.errorvalidacion.IdBisel" :Mensaje="'*'+errorvalidacion.IdBisel[0]"/>
						</div>
					</div>			
					<br>
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormArmazon',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objArmazon: {
				IdArmazon: 0,
				IdBisel: '',
				Nombre: '',
				
            },
            CmbListBiseles:[],
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objArmazon.IdArmazon == 0) {
				await this.$http.post(
					'armazones',this.objArmazon
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'armazones/'+this.objArmazon.IdArmazon,
					this.objArmazon
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "armazones/"+this.objArmazon.IdArmazon
            ).then((res) => {
                this.objArmazon = res.data.data;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        GetComboBiseles(){
            this.$http.get('/biseles',{params:{simple:1, ReqArmazon:'SI',SubRegistro:'NO'}}
            ).then((res) => this.CmbListBiseles = res.data.data
            ).catch(err => console.error(err));
        },
        Limpiar()
        {
            this.objArmazon = {
				IdArmazon: 0,
				IdBisel: '',
				Nombre: '',
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;
        this.GetComboBiseles();
        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objArmazon.IdArmazon = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
